export const getVAT = (date) => (
  (date ? new Date(date) : new Date()).getFullYear() > 2018 ? 0.2 : 0.18
);
